import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=2455d14a&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=2455d14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455d14a",
  null
  
)

export default component.exports